var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea as ChakraTextarea } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { FormControl } from '../wrappers';
export var Textarea = function (_a) {
    var name = _a.name, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, placeholder = _a.placeholder, defaultValue = _a.defaultValue, control = __rest(_a, ["name", "isDisabled", "isReadOnly", "placeholder", "defaultValue"]);
    var register = useFormContext().register;
    return (_jsx(FormControl, __assign({ name: name }, control, { children: _jsx(ChakraTextarea, { name: name, ref: register, defaultValue: defaultValue, placeholder: placeholder, isDisabled: isDisabled, isReadOnly: isReadOnly, autoComplete: "off" }, void 0) }), void 0));
};
